import { Component, OnInit } from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-nonteachingstaff',
  templateUrl: './nonteachingstaff.component.html',
  styleUrls: ['./nonteachingstaff.component.scss']
})
export class NonteachingstaffComponent implements OnInit {

  constructor(private meta: Meta,
              private titles: Title) { }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('ARNI Staff Details – Find Faculty & Staff Info');
        this.meta.updateTag({
            name: 'description',
            content: `Access detailed information about ARNI staff members. Get to know the dedicated faculty and their expertise for a better understanding of the institution.`
        });
    }

}
